export function notificationsMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      notificationsId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateNotificationsId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyNotificationss(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateNotificationsId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function notificationsMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, notificationsId: json.result.objectId},
  };
}